<section class="m-4">
  <div class="header-wrapper d-flex justify-content-between align-items-center">
    <div class="page_header">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h2 translate class="page-main-title m-0">Testimonials Details</h2>
    </div>
    <button
      mat-raised-button
      color="primary"
      class="add-accordion-btn"
      (click)="openUploadDialog()"
    >
      <i class="fa-solid fa-plus add_button"></i
      ><span translate>Add testimonial Details</span>
    </button>
  </div>

  <table
    mat-table
    [dataSource]="testimonialsData"
    class="mt-2 mat-elevation-z8 bg-white"
  >
    <ng-container matColumnDef="uploadDate">
      <th translate mat-header-cell *matHeaderCellDef>Upload Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.created_at | date: "dd/MM/yyyy" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th translate mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th translate mat-header-cell *matHeaderCellDef>Description</th>
      <td
        mat-cell
        *matCellDef="let element"
        matTooltip="{{ element.description }}"
        class="cursor_pointer"
        matTooltipPosition="below"
      >
        {{ element.description | slice: 0 : 10
        }}{{ element.description.length > 10 ? "..." : "" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="images">
      <th translate mat-header-cell *matHeaderCellDef>Video</th>
      <td mat-cell *matCellDef="let element">
        <div class="video-thumbnail-container">
          <video
            #videoPlayer
            width="100%"
            height="auto"
            controls
            [poster]="
              this.imagePath +
              '/' +
              element.media_url +
              '?alt=media&token=thumbnail_token'
            "
            class="testimonials-video"
            muted
            preload="metadata"
            (play)="viewItem(element, videoPlayer)"
          >
            <source
              [src]="this.imagePath + '/' + element.media_url"
              type="video/mp4"
            />
            <span translate>Your browser does not support the video tag.</span>
          </video>
          <div class="play-button-overlay" (click)="viewItem(element)">
            <mat-icon>play_circle_filled</mat-icon>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex align-items-center">
          <button
            translate
            mat-button
            class="view_button"
            (click)="viewItem(element)"
          >
            View
          </button>
          <button
            class="action_button"
            mat-icon-button
            [matMenuTriggerFor]="menu"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>
        </div>
        <mat-menu #menu="matMenu">
          <button
            mat-menu-item
            class="update_button"
            *ngIf="editId !== element.id"
            (click)="editItem(element)"
          >
            <mat-icon>edit</mat-icon>
            <span translate>Edit</span>
          </button>
          <button
            mat-menu-item
            class="delete_button"
            (click)="deleteItem(element.id)"
          >
            <mat-icon>delete</mat-icon>
            <span translate>Delete</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
